/***
 * @file:å¯ææ¬ç¼è¾å¨
 * @author: linkun.he
 * @Date: 2019-06-26 14:18:53
 */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';

import { I18NService } from '@ithinkdt/shared/i18n';
import { WINDOW } from '@ithinkdt/shared/utils';

declare var tinymce: any;

@Component({
  selector: 'dt-tinymce-editor',
  templateUrl: './tinymce-editor.component.html',
  styleUrls: ['./tinymce-editor.component.scss'],
})
export class TinymceEditComponent implements AfterViewInit, OnChanges, OnDestroy {
  // å¯ææ¬ç¼è¾å¨
  editor;
  storedEditorData;
  editorId: string;
  // åå§åæ°æ®
  @Input() data = '';
  // ä¸ä¼ æä»¶çå°å
  @Input() uploadUrl = '/cli/bus/file/upload.do';
  // ä¸è½½æä»¶çå°å
  @Input() downloadUrl = '/cli/bus/file/download.do';
  @Input() height = 320;
  // ç¼è¾å¨çåè½éç½®
  @Input() editModel = {
    toolbar:
      ' bold italic underline forecolor backcolor fontsizeselect fontselect | formatselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | pagebreak | image imagetools | removeformat |  undo redo fullscreen ',
  };
  // æ¯å¦ç¦ç¨ï¼ç¦ç¨æ¶ä¸æ¾ç¤ºå¤´é¨èåï¼
  @Input() disabled = false;
  // ç¼è¾å¨åå®¹åååè°
  @Output() editorContentChange = new EventEmitter();
  // å¾çä¸ä¼ åè°
  @Output() imgUpload = new EventEmitter();
  lang: any[];

  constructor(private http: HttpClient, private i18n: I18NService, @Inject(WINDOW) private win: any) {
    this.editorId = this.randomEditorId;
    this.lang = this.i18n.getLangs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('data' in changes && this.editor && this.data) {
      if (this.data === this.storedEditorData) {
        return;
      }
      this.editor.setContent(this.data);
    }
  }

  ngAfterViewInit() {
    const self = this;
    const modelConfig = this.disabled ? this.previewModel : this.editModel;
    tinymce.init({
      selector: '#' + this.editorId,
      height: this.height,
      relative_urls: false,
      remove_script_host: false,
      convert_urls: true,
      plugins: ['link', 'table', 'image', 'textcolor', 'paste', 'fullscreen'],
      ...modelConfig,
      skin_url: '/assets/skins/lightgray',
      setup: (editor) => {
        this.editor = editor;
        editor.on('keyup change', () => {
          self.storedEditorData = editor.getContent();
          self.editorContentChange.emit(self.storedEditorData);
        });
      },
      // å¾çä¸ä¼ åè½
      images_upload_handler(blobInfo, success, failure) {
        let formData;
        formData = new FormData();
        formData.append('fileInputName', 'fileData');
        formData.append('fileData', blobInfo.blob());

        self.uploadFile(self.uploadUrl, formData).subscribe((response) => {
          if (response && response['status']) {
            const fileId = response['data'][0]['fileId'];
            // const baseUrl = self.win.location.protocol + self.win.location.host;
            const url = self.downloadUrl + '?fileId=' + fileId;
            // console.log('url', url);

            // æå¾çé¾æ¥ï¼img srcæ ç­¾æ¾ç¤ºå¾ççææé¾æ¥æ¾å°ä¸é¢åè°å½æ°é
            success(url);
            self.imgUpload.emit(fileId);
          } else {
            if (response && response['messages']) {
              failure(response['messages']);
            } else {
              failure(this.i18n.interpret('fileUpload.uploadError'));
            }
          }
        });
      },
    });
    if (this.data) {
      this.editor.setContent(this.data);
    }
  }

  get previewModel() {
    return {
      menubar: false,
      statusbar: false,
      toolbar: false,
      readonly: 1,
    };
  }

  get randomEditorId() {
    return (
      (Math.random() * 10000000).toString(16).substr(0, 4) +
      +new Date().getTime() +
      +Math.random()
        .toString()
        .substr(2, 5)
    );
  }
  // ä¸ä¼ å¾ç
  private uploadFile(url: string, formData: any) {
    const self = this;
    const headers = new HttpHeaders();
    headers.set('Accept', 'application/json');
    return self.http.post(url, formData, { headers });
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }
}
